import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/data/translations";

const WhatsAppButton = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating"
      className="fixed bottom-6 right-6 z-40 group flex items-center gap-3 pl-4 pr-5 py-3 rounded-full bg-[#2B4C3E] hover:bg-[#1f3a30] text-white shadow-[0_18px_40px_-12px_rgba(43,76,62,0.7)] border border-white/10 hover:border-[#D4AF37]/50 transition-all"
    >
      <span className="relative flex items-center justify-center w-7 h-7 rounded-full bg-[#D4AF37]/15">
        <span className="absolute inset-0 rounded-full bg-[#D4AF37]/30 animate-ping opacity-50" />
        <MessageCircle className="w-4 h-4 text-[#D4AF37]" strokeWidth={1.6} />
      </span>
      <span className="hidden sm:block text-xs tracking-[0.18em] uppercase">
        WhatsApp
      </span>
    </a>
  );
};

export default WhatsAppButton;
